module.exports = __webpack_public_path__ + "img/system.2c690849.png";